module.exports = __webpack_public_path__ + "img/snowflake-01.604bb8f0.png";